import { render } from "./add_radiology_modal.vue?vue&type=template&id=085ed974&scoped=true"
import script from "./add_radiology_modal.vue?vue&type=script&lang=js"
export * from "./add_radiology_modal.vue?vue&type=script&lang=js"

import "./add_radiology_modal.vue?vue&type=style&index=0&id=085ed974&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085ed974"]])

export default __exports__